export type OrderSort = { key: "amount" | "deliveryDate"; direction: "asc" | "desc" };
type SortableOrder = { amountCnyEstimate: number; deliveryDate: string | null };
/** Sort the entire filtered result before pagination; missing dates stay last. */
export function sortOrderRows<T extends SortableOrder>(rows: readonly T[], sort: OrderSort | null): T[] {
  if (!sort) return [...rows];
  const value = (row: T): number => sort.key === "amount"
    ? (row.amountCnyEstimate == null ? NaN : Number(row.amountCnyEstimate))
    : (row.deliveryDate ? Date.parse(row.deliveryDate) : NaN);
  return rows.map((row,index)=>({row,index,value:value(row)})).sort((a,b)=>{
    const aMissing=!Number.isFinite(a.value),bMissing=!Number.isFinite(b.value);
    if(aMissing||bMissing)return aMissing===bMissing?a.index-b.index:aMissing?1:-1;
    return (sort.direction==="asc"?a.value-b.value:b.value-a.value)||a.index-b.index;
  }).map(entry=>entry.row);
}
